import Styles from './styles.module.css';
import React, { useMemo } from 'react';
import { IoImagesOutline } from 'react-icons/io5';
import { PhotoRow, StaffOption } from '../types';
import PhotoCard from './1.card/index';

type PhotoGalleryProps = {
  rows: PhotoRow[];
  staffList: StaffOption[];
  time: number;
  loading: boolean;
  onSelect: (id: string) => void;
  onOpenUpload: () => void;
};

const PhotoGallery: React.FC<PhotoGalleryProps> = ({ rows, staffList, time, loading, onSelect, onOpenUpload }) => {

  const staffNameById = useMemo(() => {
    const map = new Map<string, string>();
    staffList.forEach((s) => map.set(s.id, s.name));
    return map;
  }, [staffList]);

  // 常に新しい作品から表示する(並び替えUIは現時点では不要)
  const sorted = useMemo(
    () => [...rows].sort((a, b) => b.post_time.getTime() - a.post_time.getTime()),
    [rows]
  );

  return (
    <div className={Styles.box}>

      <div className={Styles.sectionHeader}>
        <div>
          <p className={Styles.sectionTitle}>作品撮り</p>
          <p className={Styles.sectionDesc}>サロンの技術や雰囲気が伝わる作品を登録できます</p>
        </div>

        {/* 作品が1件もない場合は下の空状態側に同じ役割のボタンがあるため、ここでは重複させない */}
        {rows.length > 0 && (
          <button className={Styles.mobileUploadButton} onClick={onOpenUpload}>＋ 画像をアップロード</button>
        )}
      </div>

      {loading ? (
        <p className={Styles.empty}>読み込み中...</p>
      ) : rows.length === 0 ? (
        <div className={Styles.emptyState}>
          <div className={Styles.emptyIcon}><IoImagesOutline /></div>
          <p className={Styles.emptyTitle}>まだ作品が登録されていません</p>
          <p className={Styles.emptyDesc}>
            作品やスタイル写真を登録すると、学生にサロンの技術や雰囲気を伝えられます。
          </p>
          <button className={Styles.uploadButton} onClick={onOpenUpload}>最初の画像をアップロード</button>
        </div>
      ) : (
        <div className={Styles.grid}>
          {sorted.map((row) => (
            <PhotoCard
              key={row.id}
              row={row}
              staffName={staffNameById.get(row.post_staff_id) ?? ''}
              time={time}
              onClick={() => onSelect(row.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default PhotoGallery;
